import React, { useState } from "react";

import useStyles from "@hooks/useStyles";

import Container from "@material-ui/core/Container";
import Grid from "@material-ui/core/Grid";
import Button from "@material-ui/core/Button";
import Box from "@material-ui/core/Box";

import Avatar from "@material-ui/core/Avatar";
import MonetizationOnOutlinedIcon from "@material-ui/icons/MonetizationOnOutlined";
import EventAvailableIcon from "@material-ui/icons/EventAvailable";
import DesktopMacIcon from "@material-ui/icons/DesktopMac";
import LineBreak from "@components/Global/Custom/Icons/LineBreak";
import BookingFunnelItems from "../Shared/BookingFunnel/BookingFunnelItems";

const WebsiteServicesClasses = () => {
	const classes = useStyles("Website");

	const backgroundColor = ""; // #ffebe5
	const backgroundGradient = ``; // for testing  linear-gradient(121.04deg,#79dfff 15.69%,#865cff)
	const backgroundImage = ``; // for testing https://wallpapercave.com/wp/wp8377155.jpg
	const coloredBox = false;

	const header = `Services & classes`;
	const subHeader = `Opening at 9:00 AM`;
	const tagline = "Isla music lessons";
	const textAlign = "left"; // left / center / right
	const lineBreak = true;
	const content = "";

	const button = "Book";
	const buttonLink = "/wesbite/about-us";

	const buttonSecondary = "My bookings";
	const buttonSecondaryLink = "/wesbite/about-us";

	const [items, setItems] = useState([
		{
			id: 12,
			category: "hvac",
			type: "service",
			title: "Service call",
			description:
				"Comprehensive maintenance service to ensure your HVAC system runs efficiently all year round. Comprehensive maintenance service to ensure your HVAC system runs efficiently all year round.",
			time: "1 hr",
			price: "0",
			//features: ["System Inspection", "Filter Replacement"],
			imageUrl:
				"https://greenleafhvac.net/wp-content/uploads/2022/12/ac-maintenance-servicing-outdoor-unit.jpg",
		},
		{
			id: 11,
			category: "hvac",
			type: "membership",
			title: "Unlimited Yoga Pass",
			description:
				"Comprehensive maintenance service to ensure your HVAC system runs efficiently all year round.",
			details: "Unlimited sessions per month • 2 services",
			time: "2 hrs",
			price: "$29 / month",
			features: ["Membership"],
			imageUrl:
				"https://greenleafhvac.net/wp-content/uploads/2022/12/ac-maintenance-servicing-outdoor-unit.jpg",
		},

		{
			id: 1,
			category: "yoga",
			type: "class",
			title: "Toddler and Me Yoga: Songs and Sensory Play",
			schedule: "Jan 15 – Apr 29",
			dayTime: "Mon, 11:00am – 12:00pm CST",
			time: "1 hr",
			ageRange: "Ages 3 – 8 yrs",
			price: "$65 / class",
			spotsLeft: "2",
			features: ["Drop-in", "Full schedule"],
			imageUrl:
				"https://static.lessons.com/assets/images/bg/thumbs/basketball.jpg",
		},
		{
			id: 2,
			category: "dance",
			type: "class",
			title: "Toddler and Me Yoga: Songs and Sensory Play",
			schedule: "Jan 15 – Apr 29",
			dayTime: "Mon, 11:00am – 12:00pm CST",
			time: "1 hr",
			ageRange: "Ages 3 – 8 yrs",
			price: "$420 / 16 classes",
			spotsLeft: "1",
			features: ["Drop-in", "Full schedule"],
			imageUrl:
				"https://static.lessons.com/assets/images/bg/thumbs/basketball.jpg",
		},
		{
			id: 3,
			category: "yoga",
			type: "service",
			title: "Toddler and Me Yoga: Private lesson",
			description:
				"*we recommend booking this if it your first ever brazilian as hard wax can be less painful than sugaring for first-timers! Your esthetician can help discuss which is best once you arrive.",
			time: `1 hr`,
			ageRange: "Ages 3 – 8 yrs",
			price: "$65",
			//spotsLeft: "2",
			imageUrl:
				"https://static.lessons.com/assets/images/bg/thumbs/basketball.jpg",
		},
		{
			id: 4,
			category: "yoga",
			type: "service",
			title: "Adult and Me Yoga: Private lesson",
			description:
				"*we recommend booking this if it your first ever brazilian as hard wax can be less painful than sugaring for first-timers! Your esthetician can help discuss which is best once you arrive.",
			time: `1 hr`,
			//ageRange: "Ages 3 – 8 yrs",
			price: "$65",
			//spotsLeft: "2",
			//imageUrl:
			//	"xxx",
		},
	]);

	const [selectedItems, setSelectedItems] = useState([]);

	// Function to toggle item selection
	const toggleItemSelection = (itemId) => {
		setSelectedItems((prevSelectedItems) =>
			prevSelectedItems.includes(itemId)
				? prevSelectedItems.filter((id) => id !== itemId)
				: [...prevSelectedItems, itemId]
		);
	};

	return (
		<React.Fragment>
			<section
				className={
					tagline || header || subHeader || lineBreak || content
						? "websiteComponent"
						: "websiteComponent thin"
				}
				style={{
					backgroundColor:
						!coloredBox && backgroundColor ? backgroundColor : "unset",
					backgroundImage:
						!coloredBox && backgroundGradient ? backgroundGradient : "unset",
				}}
			>
				{backgroundImage && (
					<Box
						position={"absolute"}
						top={0}
						bottom={0}
						width={"100%"}
						style={{
							backgroundImage: `url(${backgroundImage})`,
							backgroundRepeat: "no-repeat",
							backgroundSize: "cover",
							backgroundPosition: "50% 50%",
							opacity: "0.4",
							//filter: "blur(2px)",
						}}
						zIndex={1}
					/>
				)}

				<Container maxWidth={"lg"} disableGutters style={{ zIndex: 3 }}>
					<div
						className={coloredBox ? classes.featuredTextBox : undefined}
						style={{
							backgroundColor:
								coloredBox && backgroundColor ? backgroundColor : "",
							backgroundImage:
								coloredBox && backgroundGradient ? backgroundGradient : "unset",
						}}
					>
						<Grid
							container
							spacing={8}
							justifyContent="center"
							alignItems={
								textAlign === "left"
									? "flex-start"
									: textAlign === "right"
									? "flex-end"
									: "center"
							}
						>
							{(tagline ||
								header ||
								subHeader ||
								lineBreak ||
								content ||
								button ||
								buttonSecondary) && (
								<Grid item xs={12}>
									<Box
										display={"flex"}
										flexDirection={"column"}
										justifyContent={"center"}
										alignItems={
											textAlign === "left"
												? "flex-start"
												: textAlign === "right"
												? "flex-end"
												: "center"
										}
										height={"100%"}
									>
										{tagline && (
											<Box className="tagline" textAlign={textAlign}>
												{tagline}
											</Box>
										)}

										{header && (
											<Box component={"h2"} textAlign={textAlign}>
												{header}
											</Box>
										)}

										{subHeader && (
											<Box component={"h3"} textAlign={textAlign}>
												{subHeader}
											</Box>
										)}

										{lineBreak && (
											<Box my={1} textAlign={textAlign}>
												<LineBreak className={classes.lineBreak} />
											</Box>
										)}

										{content && (
											<>
												<Box component={"p"} textAlign={textAlign}>
													{content}
												</Box>
											</>
										)}

										{(button || buttonSecondary) && (
											<Box
												className={classes.columnButtonsBox}
												textAlign={textAlign}
												justifyContent={textAlign}
											>
												{button && (
													<Button
														size="large"
														color="primary"
														variant="contained"
														disableElevation
														href={buttonLink}
														className="columnButton"
													>
														{button}
													</Button>
												)}

												{buttonSecondary && (
													<Button
														size="large"
														color="secondary"
														variant="outlined"
														disableElevation
														href={buttonSecondaryLink}
														className="columnButton"
													>
														{buttonSecondary}
													</Button>
												)}
											</Box>
										)}
									</Box>
								</Grid>
							)}

							<Grid item xs={12}>
								{/* <BookingFunnelItems
									items={items}
									selectedItems={selectedItems}
									toggleItemSelection={toggleItemSelection}
								/> */}
							</Grid>
						</Grid>
					</div>
				</Container>
			</section>
		</React.Fragment>
	);
};

export default WebsiteServicesClasses;
